import React, {useEffect, useState} from 'react'
import SectionTitle from 'lms/components/Detail/SectionTitle'
import AddEditPlaylist from "./AddEditPlaylist"
import {savePlaylistItemOrder} from '../../../store/actions'
import {useDispatch} from 'react-redux'
import './playlist.css'

import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core'
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable'

import {SortableItem} from "./SortableItem"
import PlaylistItemViewer from "./PlaylistItemViewer"

const Playlist = ({items = [], applicationId, isEdit = false, isPremium = false}) => {

  const [playlistItems, setPlaylistItems] = useState([])
  const [selectedItem,setSelectedItem] = useState()
  const [selectedEditItem,setSelectedEditItem] = useState()
  const dispatchRedux = useDispatch()

  useEffect(() => {
    // Handle case where items are strings (IDs) instead of objects
    const processedItems = items.map(item => {
      if (typeof item === 'string') {
        // If item is a string (ID), convert it to an object with _id
        return {_id: item, id: item}
      }
      // If item is already an object, ensure it has _id
      if (!item._id && item.id) {
        return {...item, _id: item.id}
      }
      return item
    })
    
    setPlaylistItems(processedItems)
  }, [items])

  useEffect(() => {    
    if(selectedEditItem) {
      document.getElementById("contentPlayer").scrollIntoView({behavior: "smooth"})
    }
  }, [selectedEditItem])

  const sensors = useSensors(
    useSensor(PointerSensor,{
      activationConstraint: {
        distance: 8,
      },
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  )




  const handleDragEnd = event => {
    const {active, over} = event

    if (active.id !== over.id) {
      setPlaylistItems(items => {
        // Find indexes using _id to match what we're passing to SortableContext
        const oldIndex = items.findIndex(i => 
          (typeof i === 'string' ? i === active.id : i._id === active.id)
        )
        const newIndex = items.findIndex(i => 
          (typeof i === 'string' ? i === over.id : i._id === over.id)
        )
        
        if (oldIndex === -1 || newIndex === -1) {
          return items
        }
        
        const newList = arrayMove(items, oldIndex, newIndex)
        
        // Update order field on each item
        const updatedList = newList.map((item, idx) => {
          if (typeof item === 'string') {
            // For string IDs, create an object with _id and order
            return {_id: item, id: item, order: idx}
          }
          // For existing objects, update the order
          return {...item, order: idx}
        })
        
        dispatchRedux(savePlaylistItemOrder(updatedList))
        return updatedList
      })
    }
  }

  return (
    <>
      { (isEdit || (items && items.length > 0)) &&
      <SectionTitle id='contentPlayer'>Content Player</SectionTitle>
      }
    
      {isPremium &&
      <AddEditPlaylist isEdit={isEdit} editItem={selectedEditItem} inPlayerViewItem={selectedItem} setSelectedItem={setSelectedItem} onClearEditItem={() => setSelectedEditItem()} />
      }

      {isEdit && !isPremium &&
      <p>Contact the administrator to set up the Content Player for your account.</p>
      }
     
      { items && items.length > 0 &&
      <div className='playlist'>
        <PlaylistItemViewer item={selectedItem} applicationId={applicationId} trackViews={!isEdit} isPremium={isPremium} />
        {
          <DndContext
            sensors={sensors}
            collisionDetection={closestCenter}
            onDragEnd={handleDragEnd}
          >
            <SortableContext
              items={playlistItems.map(item => 
                typeof item === 'string' ? item : item._id
              )}
              strategy={verticalListSortingStrategy}
            >
              <div className='playlist-inner-wrapper'>
                {playlistItems.map((item, index) => (
                  <SortableItem 
                    editable={isEdit} 
                    key={item._id} 
                    id={item._id} 
                    item={item} 
                    setSelectedItem={setSelectedItem} 
                    editSelectedItem={setSelectedEditItem}
                  />
                ))}
              </div>
            </SortableContext>
          </DndContext>

        }
      </div>
      }
    </>
  )
}

export default Playlist
